import React from 'react';
import { DisplayMode } from 'components/Experiment/constants';
import withCanvasContainer, { WithCanvasContainerProps } from './withCanvasContainer';
import WellVirtualPlateWithIngredients from './wellVirtualPlateWithIngredients';

interface Props extends WithCanvasContainerProps {
  displayMode: DisplayMode;
  highlightedWellNumbers: Array<number>;
}

const DesignCanvas = (props: Props) => {
  const { displayMode } = props;
  return (
    <>
      <WellVirtualPlateWithIngredients {...props} displayMode={displayMode} />
    </>
  );
};

export default withCanvasContainer(DesignCanvas, 'designCanvas');
